<template>
  <BackBtn v-if="route.name !== 'Home'" />
  <router-view />
  <FooterNavigation />
</template>

<script setup>
import { useRoute } from "vue-router";
import FooterNavigation from "@/components/FooterNavigation.vue";
import BackBtn from "./components/backBtn.vue";

const route = useRoute();
</script>
<style>
/* .wrapper {
    overflow-x: hidden;
  } */
body {
  background: url("@/assets/mainbg.png");
  background-size: 100% 100%;
}
.hover {
  border: 8px solid;
  border-image: repeating-linear-gradient(
      135deg,
      #2c4fa1 0 10px,
      #2c4fa1 0 20px,
      #2c4fa1 0 30px
    )
    8;
  -webkit-mask: conic-gradient(
        from 180deg at top 8px right 8px,
        #0000 90deg,
        #000 0
      )
      var(--_i, 200%) 0 /200% var(--_i, 8px) border-box no-repeat,
    conic-gradient(at bottom 8px left 8px, #0000 90deg, #000 0) 0
      var(--_i, 200%) / var(--_i, 8px) 200% border-box no-repeat,
    linear-gradient(#000 0 0) padding-box no-repeat;
  transition: 0.3s, -webkit-mask-position 0.3s 0.3s;
}
.hover:hover {
  cursor: pointer;
  --_i: 100%;
  color: #cc333f;
  transition: 0.3s, -webkit-mask-size 0.3s 0.3s;
}
.disabled-card {
  opacity: 0.4;
  pointer-events: none;
  filter: grayscale(100%);
  cursor: not-allowed;
}
</style>
